import React from "react";
import { Col } from "react-bootstrap";
import {
  AuditFields,
  DetailTable,
  EditButton,
  Detail as DetailRow
} from "MODULES/shared/components";
import { connect } from "react-redux";
import T from "prop-types";
import { Map, fromJS } from "immutable";
import loadRecord from "MODULES/shared/decorators/loadRecord";
import {
  ACCOUNTING,
  QUALITY_CONTROL,
  USER,
  WAREHOUSE_LOGISTICS_DIRECTOR,
  WAREHOUSE_MANAGER
} from "MODULES/users/constants";
import Attachments from "MODULES/shared/components/Attachments/Attachments";
import Notes from "MODULES/shared/components/Notes/Notes";
import resourceTypes from "MODULES/shared/types/resourceTypes";
import DashedSeparator from "MODULES/shared/components/DashedSeparator/DashedSeparator";
import { hasAnyOfRolesOrSubroles, hasSubRole } from "MODULES/users/helpers";
import {
  ATTACHMENT_TYPES,
  COST_SPLIT_LABEL,
  LOT,
  LOT_NAME,
  LOT_TYPE,
  LOT_TYPES
} from "MODULES/Lots/constants";
import { VendorDetail } from "MODULES/shared/components/VendorDetail/VendorDetail";
import { ShippingPreference } from "MODULES/Orders/shared/ShippingPreference";
import LineItemsTable from "MODULES/Lots/Detail/LineItemsTable/LineItemsTable";
import { properCase } from "LIB/formatters/text";
import { REFERENCE_NUMBER_LABEL } from "APP_ROOT/constants";
import { CONDITION, LEAD_TIME_LABEL } from "MODULES/inventories/constants";
import { CONDITIONS } from "MODULES/Shipping/constants";
import { dollars } from "LIB/formatters/currency";
import EditVendor from "MODULES/Lots/Detail/Edit/EditVendor/EditVendor";
import ShippingDetails from "MODULES/Lots/Detail/ShippingDetails/ShippingDetails";
import EditLot from "MODULES/Lots/Detail/Edit/EditLot/EditLot";
import Note from "MODULES/shared/components/Note/Note";
import { EXTERNAL_NOTE, INTERNAL_NOTE } from "MODULES/PurchaseOrders/constants";
import Billing from "MODULES/Lots/Detail/Billing/Billing";
import { ApprovalDetails } from "MODULES/shared/components/ApprovalDetails/ApprovalDetails";
import Authorized from "MODULES/shared/components/Authorized/Authorized";
import CostAdjustmentTable from "MODULES/inventories/components/Detail/CostAdjustmentTable/CostAdjustmentTable";
import AddCostAdjustment from "MODULES/Lots/Detail/AddCostAdjustment/AddCostAdjustment";
import { percentFormatter } from "MODULES/shared/components/StatsTooltip/format";
import { lotLineItemsPagination } from "MODULES/Lots/pagination";
import Search from "./LineItemsTable/Search";
import Header from "./Header";
import { show, update } from "../actions";
import AddPart from "./LineItemsTable/AddPart/AddPart";
import ReceivingRecordsTable from "./ReceivingRecordsTable/ReceivingRecordsTable";

const EDIT_LOT_MODAL = "editLotModal";
const EDIT_VENDOR_MODAL = "editVendorModal";
const ADD_PART_MODAL = "addPartModal";
const ADD_COST_ADJUSTMENT_MODAL = "addCostAdjustmentModalOpen";

export class Detail extends React.Component {
  static propTypes = {
    lot: T.instanceOf(Map),
    currentUser: T.instanceOf(Object),
    location: T.shape({
      state: T.shape({
        part: T.instanceOf(Object),
        open: T.bool,
        id: T.number
      })
    })
  };

  state = {
    editModalOpen: false,
    addPartModalOpen: false,
    addCostAdjustmentModalOpen: false,
    editInvoiceModalOpen: false,
    editPartModalOpen: false,
    initialPartFormValues: {}
  };

  componentWillMount() {
    if (this.props.location.state && this.props.location.state.open) {
      this.setState({
        addPartModalOpen: true,
        initialPartFormValues: this.props.location.state.part,
        id: this.props.location.state.id
      });
    }
  }

  toggleModal = modal => () => this.setState({ [modal]: !this.state[modal] });

  openEditModal = () => {
    this.setState({ openEditModal: true });
  };

  openEditInvoiceModal = () => {
    this.setState({ editInvoiceModalOpen: true });
  };

  userCanEdit() {
    const { currentUser } = this.props;
    const lot = this.props.lot.toJS();
    const { buyer_id: buyerId, co_buyer_id: coBuyerId } = lot;

    return (
      hasAnyOfRolesOrSubroles(
        currentUser,
        [ACCOUNTING, QUALITY_CONTROL],
        [WAREHOUSE_LOGISTICS_DIRECTOR]
      ) ||
      currentUser.id === buyerId ||
      currentUser.id === coBuyerId
    );
  }

  shippingDetailsUnlocked() {
    const { currentUser } = this.props;

    const userCanEdit = this.userCanEdit();
    const isWarehouseManager = hasSubRole(currentUser, WAREHOUSE_MANAGER);
    return userCanEdit || isWarehouseManager;
  }

  render() {
    const lot = this.props.lot.toJS();
    const {
      [EDIT_LOT_MODAL]: editLotModalOpen,
      [EDIT_VENDOR_MODAL]: editVendorModalOpen,
      [ADD_PART_MODAL]: addPartModalOpen,
      [ADD_COST_ADJUSTMENT_MODAL]: addCostAdjustmentModalOpen,
      initialPartFormValues,
      id
    } = this.state;

    const remainingCost = lot.cost - lot.applied_cost;

    return (
      <div>
        <Header lot={fromJS(lot)} received={lot.received} />
        <div className="row">
          <Col md={3}>
            <div className="panel panel-default">
              <div className="panel-body">
                <h2 style={{ marginTop: 10 }}>
                  Details
                  <EditButton
                    handleClick={this.toggleModal(EDIT_VENDOR_MODAL)}
                  />
                  <EditVendor
                    lot={lot}
                    open={editVendorModalOpen}
                    close={this.toggleModal(EDIT_VENDOR_MODAL)}
                  />
                </h2>
                <VendorDetail record={lot} />
                <DashedSeparator />
                <div>
                  <h2>
                    Lot Details
                    <EditButton
                      handleClick={this.toggleModal(EDIT_LOT_MODAL)}
                    />
                    <EditLot
                      lot={lot}
                      open={editLotModalOpen}
                      close={this.toggleModal(EDIT_LOT_MODAL)}
                    />
                  </h2>
                  <DetailTable>
                    <DetailRow
                      label={properCase(LOT_TYPE)}
                      value={LOT_TYPES[lot.lot_type].label}
                    />
                    <DetailRow label={properCase(LOT_NAME)} value={lot.name} />
                    <DetailRow
                      label={REFERENCE_NUMBER_LABEL}
                      value={lot.reference_number}
                    />
                    <DetailRow label={LEAD_TIME_LABEL} value={lot.lead_time} />
                    {lot.condition && (
                      <DetailRow
                        label={properCase(CONDITION)}
                        value={CONDITIONS[lot.condition].label}
                      />
                    )}
                    <DetailRow
                      label="Original Cost"
                      value={dollars(lot.original_cost)}
                    />
                    <DetailRow label="Total Cost" value={dollars(lot.cost)} />
                    <DetailRow
                      label="Applied Cost"
                      value={dollars(lot.applied_cost)}
                    />
                    <DetailRow
                      label="Remaining Cost"
                      value={dollars(remainingCost < 0 ? 0 : remainingCost)}
                    />
                    <DetailRow
                      label={COST_SPLIT_LABEL}
                      value={lot.cost_split && percentFormatter(lot.cost_split)}
                      renderIfPresent
                    />
                    <DetailRow
                      label="Total Sales"
                      value={dollars(lot.total_sales)}
                    />
                    <DetailRow
                      label="Total Profit"
                      value={dollars(lot.total_profit)}
                    />
                  </DetailTable>
                </div>
                <ApprovalDetails record={lot} />
                <Billing />
                <DashedSeparator />
                <ShippingDetails lot={lot} />
                {lot.shipping_method && (
                  <ShippingPreference shippingMethod={lot.shipping_method} />
                )}
                <DashedSeparator />
                <AuditFields record={fromJS(lot)} multiLine />
              </div>
            </div>
          </Col>
          <Col md={9}>
            <h2 style={{ marginTop: 26 }}>
              Cost Adjustments
              <Authorized roles={[ACCOUNTING, QUALITY_CONTROL]}>
                <button
                  key="cost-adjustment"
                  type="button"
                  className="btn btn-primary btn-hollow pull-right"
                  onClick={this.toggleModal(ADD_COST_ADJUSTMENT_MODAL)}
                >
                  <i className="fa fa-fw fa-plus">&nbsp;</i>Add Cost Adjustment
                </button>
                <AddCostAdjustment
                  key="add-cost-adjustment-modal"
                  close={this.toggleModal(ADD_COST_ADJUSTMENT_MODAL)}
                  open={addCostAdjustmentModalOpen}
                  lot={lot}
                />
              </Authorized>
            </h2>
            <CostAdjustmentTable costAdjustments={lot.lot_cost_adjustments} />
            <h2 style={{ marginTop: 26 }}>
              Parts
              <button
                type="button"
                className="btn btn-primary btn-hollow pull-right"
                onClick={this.toggleModal(ADD_PART_MODAL)}
              >
                <i className="fa fa-fw fa-plus">&nbsp;</i>
                Create New
              </button>
              <AddPart
                open={addPartModalOpen}
                close={this.toggleModal(ADD_PART_MODAL)}
                part={initialPartFormValues}
                id={id}
              />
            </h2>

            <Search />
            <LineItemsTable lot={lot} />
            <div className="row">
              <Col sm={12}>
                <h2 style={{ marginTop: 26 }}>Received</h2>
                <ReceivingRecordsTable />
              </Col>
            </div>
            <div className="row">
              <Col sm={6}>
                <Note
                  header={properCase(INTERNAL_NOTE)}
                  record={lot}
                  update={update}
                  type={INTERNAL_NOTE}
                />
              </Col>
              <Col sm={6}>
                <Note
                  header={properCase(EXTERNAL_NOTE)}
                  type={EXTERNAL_NOTE}
                  record={lot}
                  update={update}
                />
              </Col>
            </div>
            <Notes
              headerLabel="Follow Up Notes"
              resource={fromJS(this.props.lot)}
              resourceType={resourceTypes.lot}
              resourceKey="purchaseOrder"
            />
            <Notes
              resource={fromJS(this.props.lot)}
              resourceType={resourceTypes.lot}
              resourceKey="lot"
              trace
            />
            <hr className="hr-dashed" />
            <Attachments
              attachmentTypes={ATTACHMENT_TYPES}
              multiple
              resource={fromJS(lot)}
              resourceType={resourceTypes.lot}
              resourceKey="lot"
            />
          </Col>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    lot: state.lotDetail.get(LOT),
    currentUser: state.session.get(USER).toJS()
  }),
  dispatch => ({
    search: val => dispatch(lotLineItemsPagination.setFilter("filter", val))
  })
)(
  loadRecord({
    reducer: "lotDetail",
    name: "lot",
    action: show
  })(Detail)
);



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/Detail.jsx